import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { UserManager } from '../../Services/UserManager/user-manager';
@Component({
  selector: 'app-entity',
  templateUrl: './entity.component.html',
  styleUrls: ['./entity.component.css']
})
export class EntityComponent implements OnInit {

  constructor(
    private route: ActivatedRoute,
    private um: UserManager
  ) { }

  ngOnInit() {
  }
  ngAfterViewInit() {
    const id = this.route.snapshot.paramMap.get('id')
    this.um.openSignUpWithCode(id)
  }
  
}

 
